import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "./utils.js";
export const buttonVariants = cva("inline-flex min-h-10 items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition-[background-color,color,border-color,box-shadow,transform] outline-none select-none disabled:pointer-events-none disabled:opacity-50 focus-visible:ring-3 focus-visible:ring-emerald-700/20 focus-visible:ring-offset-2 active:translate-y-px", {
    variants: {
        size: {
            default: "h-11",
            icon: "size-10 px-0",
            sm: "h-9 min-h-9 rounded-lg px-3 text-xs",
        },
        variant: {
            default: "bg-emerald-800 text-white shadow-sm hover:bg-emerald-900 hover:shadow-md",
            destructive: "bg-red-700 text-white hover:bg-red-800",
            ghost: "text-stone-600 hover:bg-stone-100 hover:text-stone-950",
            outline: "border border-stone-300 bg-surface text-stone-800 shadow-xs hover:border-emerald-700 hover:text-emerald-900",
        },
    },
    defaultVariants: { size: "default", variant: "default" },
});
export function Button({ className, size, type = "button", variant, ...props }) {
    return (_jsx("button", { className: cn(buttonVariants({ className, size, variant })), type: type, ...props }));
}
